import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../../redux/slices/authSlice";
import pendingUserReducer from "../../redux/slices/pendingUserSlice";
import profileReducer from "../../redux/slices/profileSlice";

import companyRoleReducer from "../../redux/slices/companyRoleSlice";
import propertyReducer from "../../redux/slices/propertySlice";
import unitReducer from "../../redux/slices/unitSlice";
import propertyTypeReducer from "../../redux/slices/propertyTypeSlice";
import propertyStatusReducer from "../../redux/slices/propertyStatusSlice";
import locationReducer from "../../redux/slices/locationSlice";
import propertyCommissionReducer from "../../redux/slices/propertyCommissionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    pendingUsers: pendingUserReducer,
    profile: profileReducer,
    companyRole: companyRoleReducer,
    property: propertyReducer,
    unit: unitReducer,
    propertyTypes: propertyTypeReducer,
    propertyStatuses: propertyStatusReducer,
    locations: locationReducer,
    propertyCommissions: propertyCommissionReducer,
  },
});

export default store;
